var _circle, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBird(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    fill: "#222222",
    r: 12
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#2d2d2d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m18.9285 6.4393c-.0009-.34404-.3784-.55447-.6695-.37213-3.3061 2.07147-6.7817 5.28923-8.38171 5.33173-1.34828-1.2158-2.43132-1.67115-3.30816-1.3917-.75693.2412-1.2814 1.0175-1.5588 2.3073-.07774.3616.29817.6526.62631.485.70894-.362 1.22133-.3736 1.71-.0379.94183.756.80091 3.181 2.04351 3.8294.81425.4249 1.82125.458 2.99975.1.1905.976 1.1494 1.7086 1.9847 2.2406.107.0682.2414.0881.3678.0475 1.9833-.6372 3.5624-2.3108 2.6126-4.1047-.0964-.1819-.3055-.2723-.5034-.2173-.7911.2201-1.6274.155-2.5551-.199l-.3967-.2626c4.0405-.3919 5.0388-3.661 5.0287-7.7562z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.1922 10.6429c.6587-.258 1.6643-1.11045 2.2361-1.60216-.1868-1.14807-.6795-2.11914-1.3731-2.91939-.1998-.23063-.533-.11632-.6016.20618l-.81102 3.80897c.17929.1498.36242.3185.54962.5064z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBird);
export default __webpack_public_path__ + "static/media/bird.59f98018990764ffe88f09dd296771d7.svg";
export { ForwardRef as ReactComponent };